module.exports = __webpack_public_path__ + "img/refresh.fa7238f1.svg";